// styles and images
import './Project.css'
import Edit from '../../assets/edit.svg'


export default function ProjectSummary({project, setEditIsTriggered, isArchive}) {
  
  return (
    <div className="col-4">
        <div className="p-2 border text-center project-card">
          <div className='d-flex justify-content-between project-header'>
            <h5>{project.customer_name} | {project.vendor_name}</h5>
              {!isArchive && <img 
                src={Edit}
                className='project-edit-image'
                alt='edit'
                onClick={() => setEditIsTriggered(true)}
              />}
          </div>
          <h6>Customer Rate Sheet | {project.customer_rates}</h6>
          <h6>Vendor Rate Sheet | {project.vendor_rates}</h6>
          <h6>Customer FSC Rate Sheet | {project.customer_fsc_rates}</h6>
          <h6>Vendor FSC Rate Sheet | {project.vendor_fsc_rates}</h6>
          <h6>Fuel Surcharge Area | {project.fsc_area_name}</h6>
          <h6>Project ID | {project.tms_project_number}</h6>
        </div>
    </div>
  )
}
